import angular from 'angular'
import ngRedux from 'ng-redux'
import { selectSaleFinalTaxDisplay } from '../../../state/slices/currentSale/currentSaleSlice'
import { RootState } from '../../../state/store'
import { SaleTaxBreakdownPopoverController } from './sale-tax-breakdown-popover.controller'
import template from './sale-tax-breakdown-popover.html'

/**
 * Controller for the sale-tax-breakdown component.
 *
 * @class SaleTaxBreakdownController
 */
export class SaleTaxBreakdownController {
  public taxDisplayProperties: {
    taxName: string
    showRemoveAll: boolean
    showTaxBreakdown: boolean
  } = {
    taxName: '',
    showRemoveAll: false,
    showTaxBreakdown: false,
  }

  constructor(
    private vdPopover: $TSFixMe,
    private readonly $ngRedux: ngRedux.INgRedux,
    $scope: angular.IScope
  ) {
    'ngInject'
    const disconnect = this.$ngRedux.connect((state: RootState) => ({
      taxDisplayProperties: selectSaleFinalTaxDisplay(state),
    }))(this)
    $scope.$on('$destroy', disconnect)
  }

  /**
   * Toggle the sale tax breakdown popover.
   *
   * @method toggleTaxBreakdownPopover
   *
   * @param  {Event} event
   *         The DOM event for the click of the tax breakdown link that triggered the toggling of the popover
   */
  public toggleTaxBreakdownPopover(event: Event) {
    this.vdPopover.open({
      trigger: event.currentTarget,
      template,
      direction: 'left',
      controller: SaleTaxBreakdownPopoverController,
    })
  }
}
